import { areas } from '@/externals/gyym/user'
import { AreaId } from './types'

export const getArea = async (areaId: AreaId) => await areas.get(areaId)
